import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Skeleton } from "@/components/ui/skeleton";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useDealContext } from "@/hooks/use-deal-context";
import { useDealStatus } from "@/components/deal-v2/DealHeader";
import { toast } from "@/hooks/use-toast";
import Sensitivity from "./Sensitivity";

const DealV2Sensitivity = () => {
  const { dealId } = useParams<{ dealId: string }>();
  const navigate = useNavigate();
  const { context, loading, error } = useDealContext(dealId || "");
  const { status: dealStatus, loading: statusLoading } = useDealStatus(dealId);

  useEffect(() => {
    if (!loading && !error && dealId && Object.keys(context).length > 0) {
      sessionStorage.setItem("brickshare_context", JSON.stringify(context));
      sessionStorage.setItem("brickshare_deal_id", dealId);
    }
  }, [context, loading, error, dealId]);

  useEffect(() => {
    if (!dealId || statusLoading) return;
    if (dealStatus && dealStatus !== "complete") {
      toast({ title: "Complete the deal to see its analysis." });
      navigate(`/deals-v2/${dealId}`, { replace: true });
    }
  }, [dealId, dealStatus, statusLoading, navigate]);

  if (loading) {
    return <Skeleton className="h-64 w-full rounded-lg" />;
  }

  if (error || !dealId) {
    return (
      <div className="text-center">
        <h1 className="font-display text-2xl font-bold tracking-tight mb-2">Deal Not Found</h1>
        <p className="text-sm text-muted-foreground mb-6">{error || "Invalid deal ID."}</p>
        <Button variant="outline" onClick={() => navigate("/deals-v2")}>
          <ArrowLeft className="mr-2 h-4 w-4" /> Back to Deals
        </Button>
      </div>
    );
  }

  return <Sensitivity />;
};

export default DealV2Sensitivity;
